import React, { useEffect, useState } from 'react';
import { DialogContent, IconButton, Typography } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { isMobile, isTablet } from 'react-device-detect';
import { IPickupTask } from '../../../interfaces/delivery-company/tasks';
import { generateQRCode } from '../../common/waybill-printer/waybill-printer-minified';
import { pickupTaskToQRcodeID } from '../../../utils/pickup-tasks';
import CustomDialog from '../../common/custom-dialog/custom-dialog';
import QRCodeBox from '../../common/qrcode-box/qrcode-box';
import ItemsCount from '../../common/labels-input/items-count/items-count';
import DriverPickupTaskPageOnlyOrder from '../driver-pickups/driver-pickup-task';

interface PickupTaskQuickScanDialogProps {
  task: IPickupTask;
  onClose: () => void;
}

function PickupTaskQuickScanDialog({
  task,
  onClose,
}: PickupTaskQuickScanDialogProps) {
  return (
    <CustomDialog
      open={true}
      onClose={onClose}
      fullWidth
      fullScreen={(isMobile && !isTablet)}
      maxWidth="xl"
    >
      <DialogContent>
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
          }}
        >
          <IconButton onClick={onClose}>
            <ClearIcon color="primary" fontSize="large" />
          </IconButton>
        </div>
        <DriverPickupTaskPageOnlyOrder pickuptaskId={task.id} />
      </DialogContent>
    </CustomDialog>
  );
}

export default PickupTaskQuickScanDialog;
